export interface Country {
  name: string;
  code: string;
  timeZones: string[];
}
